import React from "react";

const PermanentDeleteIcon = ({ size = 14, fill = "var(--du-color-red)", ...props }) => (
  <svg width={size} height={size} viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M11.8922 4.81766H11.5708C11.7476 4.81766 11.8922 4.67302 11.8922 4.49623V4.81766H24.1065V4.49623C24.1065 4.67302 24.2512 4.81766 24.428 4.81766H24.1065V7.71052H26.9994V4.49623C26.9994 3.07793 25.8463 1.9248 24.428 1.9248H11.5708C10.1525 1.9248 8.99937 3.07793 8.99937 4.49623V7.71052H11.8922V4.81766ZM32.1422 7.71052H3.85652C3.14535 7.71052 2.5708 8.28507 2.5708 8.99623V10.2819C2.5708 10.4587 2.71544 10.6034 2.89223 10.6034H5.31902L6.31143 31.6168C6.37571 32.9869 7.50875 34.0677 8.87884 34.0677H27.1199C28.494 34.0677 29.623 32.9909 29.6873 31.6168L30.6797 10.6034H33.1065C33.2833 10.6034 33.428 10.4587 33.428 10.2819V8.99623C33.428 8.28507 32.8534 7.71052 32.1422 7.71052ZM26.8105 31.1748H9.18821L8.21589 10.6034H27.7829L26.8105 31.1748Z'
      fill={fill}
    />
    <path
      d='M17.168 20.568L14.304 16.328H16.592L18.48 19.272L20.368 16.328H22.656L19.76 20.568L22.8 25H20.512L18.48 21.848L16.448 25H14.16L17.168 20.568Z'
      fill={fill}
    />
  </svg>
);

export default PermanentDeleteIcon;
